export default __webpack_public_path__ + "static/media/loginlogo.8d4d83ee.png";